import { storableError } from '../../util/errors';

// ================ Action types ================ //

export const RECOVERY_REQUEST = 'app/PasswordRecoveryPage/RECOVERY_REQUEST';
export const RECOVERY_SUCCESS = 'app/PasswordRecoveryPage/RECOVERY_SUCCESS';
export const RECOVERY_ERROR = 'app/PasswordRecoveryPage/RECOVERY_ERROR';
export const INITIATE_EMAIL = 'app/PasswordRecoveryPage/INITIATE_EMAIL';
export const CLEAR_RECOVERY_ERROR = 'app/PasswordRecoveryPage/CLEAR_RECOVERY_ERROR';

// ================ Reducer ================ //

const initialState = {
    initialEmail: null,
    submittedEmail: null,
    recoveryError: null,
    recoveryInProgress: false,
    passwordRequested: false,
};

export default function reducer(state = initialState, action = {}) {
    const { type, payload } = action;
    switch (type) {
        case RECOVERY_REQUEST:
            return {
                ...state,
                submittedEmail: null,
                recoveryInProgress: true,
                recoveryError: null,
            };
        case RECOVERY_SUCCESS:
            return {
                ...state,
                submittedEmail: payload.email,
                initialEmail: payload.email,
                recoveryInProgress: false,
                passwordRequested: true,
            };
        case RECOVERY_ERROR:
            return {
                ...state,
                recoveryInProgress: false,
                recoveryError: payload.error,
                initialEmail: payload.email,
            };
        case CLEAR_RECOVERY_ERROR:
            return { ...state, recoveryError: null };
        case INITIATE_EMAIL:
            return {
                ...state,
                initialEmail: payload.email,
            };
        default:
            return state;
    }
}

// ================ Action creators ================ //

export const initiateEmail = email => ({ type: INITIATE_EMAIL, payload: { email } });
export const passwordRecoveryRequest = () => ({ type: RECOVERY_REQUEST });
export const passwordRecoverySuccess = email => ({ type: RECOVERY_SUCCESS, payload: { email } });
export const clearPasswordRecoveryError = () => ({ type: CLEAR_RECOVERY_ERROR });
export const passwordRecoveryError = (error, email) => ({
    type: RECOVERY_ERROR,
    payload: { error, email },
    error: true,
});

// ================ Thunks ================ //

export const recoverPassword = email => (dispatch, getState, sdk) => {
    dispatch(passwordRecoveryRequest());

    return sdk.passwordReset
        .request({ email })
        .then(() => dispatch(passwordRecoverySuccess(email)))
        .catch(e => dispatch(passwordRecoveryError(storableError(e), email)));
};
